/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CrowdstrikeGlobalSecretSpec } from './crowdstrikeGlobalSecretSpec';
import { CarbonBlackGlobalSecretSpec } from './carbonBlackGlobalSecretSpec';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { SddcVmcGlobalSecretSpec } from './sddcVmcGlobalSecretSpec';


export interface GlobalSecretsUpsertSpec { 
    carbon_black?: CarbonBlackGlobalSecretSpec;
    cloud_provider?: CloudProvidersEnum;
    crowdstrike?: CrowdstrikeGlobalSecretSpec;
    sddc_vmc?: SddcVmcGlobalSecretSpec;
}
export namespace GlobalSecretsUpsertSpec {
}


